import { Button, Card, Flex, Row } from 'antd';
import { FC } from 'react';
import RegistrationForm from "../auth/form/RegistrationForm";
import './form/form.module.scss';
import { useNavigate } from 'react-router-dom';
import { RouteNames } from '../../router/routeNames';
import s from './form/form.module.scss';

const Registration: FC = () => {
    const router = useNavigate()

    const clickLogin = () => {
        router(RouteNames.LOGIN)
    }
    return (
      <>
          <div style={{position: 'absolute', right: 20, top: 30}}>
              <p style={{display: 'inline', margin: 10, fontWeight: 600, fontFamily: 'Manrope'}}>Уже зарегистрированны?</p>
              <Button onClick={clickLogin} type='primary' style={{width: 200}}>Войти</Button>
          </div>
          <Row justify="space-around" align="middle" className={'layout'}>
            <Card className={s.cardform}>
                  <Flex justify='center' align='center' vertical>
                      <RegistrationForm clickLogin={clickLogin}/>
                  </Flex>
              </Card>
          </Row>
      </>
    );
};

export default Registration;
